import React from 'react';
import Text from '@dbk/ui-text';
import Modal from '@dbk/ui-modal';
import Button from '@dbk/ui-buttons';
import styles from '../../screens/payments/payment-confirmation.styles';
import { StyleSheet } from 'react-native';
const FormBackConfirmModal = ({ onConfirm, onClose, messages, isModifyFlow }) => (
  <Modal
    isActive
    hideCloseButton
    header={messages['app.warning.text']}
    onClose={onClose}
    content={
      <div className="padding-20">
       {isModifyFlow? <Text tabIndex={0} secondary>{messages['app.payments.summary.modifyPaymentCancelMsg']}</Text> :<Text tabIndex={0} secondary>{messages['app.payments.summary.newPaymentCancelMsg']}</Text>}
        {/* <div className="text-center" style={{ marginTop: '20px' }}>
          <Button
            size="large"
            onPress={() => { onConfirm(); onClose() }}>
            {messages['app.common.formGoBackModal.btnConfirm']}
          </Button>
        </div> */}
       {/* WMCE-12018 -On payment input (either new payment or modify existing payment), the 'back' action raises the popup with different messages with actions "Proceed" and "Cancel" . */}
        <div style={StyleSheet.flatten(styles.paymentBtnBlock)}>         
            <div className="payment-btn" style={{width: '150px', marginRight: '10px'}} >
              <Button             
                size="medium"
                tertiary
                fullWidth
                margin
                onPress={()=>onClose()} >
                {messages['app.payments.summary.cancel']}
              </Button>
            </div>
            <div className="payment-btn" style={{width: '150px', marginRight: '10px'}}>
              <Button
                tabIndex={0}
                size="medium"
                className="payment-btn proceed"
                fullWidth
                onPress={() => { onConfirm(); onClose() }}>
               {messages['app.trade.label.proceed']}
              </Button>
            </div>
          </div>

      </div>
    }
  />
)

export default FormBackConfirmModal